var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZoomInWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 6.51318H0V2.51318C0 1.98275 0.210714 1.47404 0.585786 1.09897C0.960859 0.723897 1.46957 0.513184 2 0.513184L6 0.513184V2.51318H2V6.51318Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 6.51318H14V2.51318H10V0.513184H14C14.5304 0.513184 15.0391 0.723897 15.4142 1.09897C15.7893 1.47404 16 1.98275 16 2.51318V6.51318Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 16.5132H10V14.5132H14V10.5132H16V14.5132C16 15.0436 15.7893 15.5523 15.4142 15.9274C15.0391 16.3025 14.5304 16.5132 14 16.5132Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 16.5132H2C1.46957 16.5132 0.960859 16.3025 0.585786 15.9274C0.210714 15.5523 0 15.0436 0 14.5132V10.5132H2V14.5132H6V16.5132Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomInWhite);
export default __webpack_public_path__ + "static/media/zoom-in-white.2055787e3034235265268175c342a4da.svg";
export { ForwardRef as ReactComponent };